"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    bonusPoints: {
        height: 31,
        backgroundColor: theme.palette.error.main,
        display: 'flex',
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        bottom: 0
    },
    bonusPointContent: {
        color: theme.palette.error.contrastText,
        position: 'relative',
        '&:before': {
            border: 0,
            content: '""',
            position: 'absolute',
            right: -22,
            top: -8,
            borderStyle: 'solid',
            borderTopWidth: 16,
            borderTopColor: theme.palette.error.main,
            borderBottomWidth: 15,
            borderBottomColor: theme.palette.error.main,
            borderRightWidth: 15,
            borderRightColor: 'transparent',
            borderLeftColor: 'transparent',
            borderLeftWidth: 11
        }
    }
});
exports.default = styles;
//# sourceMappingURL=BonusPointsStyles.js.map